import * as React from 'react';
import { CardSection, IconCalendarDate } from '@maiia/design-system';
import { css, styled } from '@mui/material/styles';
import { Dayjs } from 'dayjs';
import { useTranslation } from '@/src/i18n';

/* JS styling */

const FirstAvailabilityWrapper = styled(CardSection, {
  shouldForwardProp: () => true,
})(
  ({ theme }) => css`
    .card-section-icon,
    .card-section-title {
      color: ${theme.palette.secondary.main};
    }
  `,
);

/* Component */

type ComponentProps = {
  fromText: string;
  dateText: string;
};

const FirstAvailabilityMobileComponent = (props: ComponentProps) => {
  const { fromText, dateText } = props;

  return (
    <FirstAvailabilityWrapper icon={<IconCalendarDate />} title={fromText}>
      <strong>{dateText}</strong>
    </FirstAvailabilityWrapper>
  );
};

type Props = {
  closestDate: Dayjs;
};

const FirstAvailabilityMobile = (props: Props) => {
  const { closestDate } = props;
  const { t } = useTranslation();

  if (closestDate.isToday()) {
    return (
      <FirstAvailabilityMobileComponent
        fromText={t('next_availability')}
        dateText={t('today')}
      />
    );
  }

  if (closestDate.isTomorrow()) {
    return (
      <FirstAvailabilityMobileComponent
        fromText={t('next_availability')}
        dateText={t('tomorrow')}
      />
    );
  }

  // other dates
  return (
    <FirstAvailabilityMobileComponent
      fromText={t('closest_availability')}
      dateText={closestDate?.format('dddd DD MMMM')}
    />
  );
};

export default FirstAvailabilityMobile;
